export const CUSTOM_VIDEO_COMMAND_NAME = 'customAddVideo';
export const CUSTOM_IMAGE_COMMAND_NAME = 'customAddImage';
export const IMAGE_EDIT_COMMAND_NAME = 'editImage';
export const IMAGE_EDIT_MARGINS_COMMAND_NAME = 'editImageMargins';
export const ELEMENT_INSERT_COMMAND_NAME = 'elementInsert';
export const CUSTOM_AUDIO_COMMAND_NAME = 'customAddAudio';
export const EQUATION_COMMAND_NAME = 'equationInsert';

// AIDEV-NOTE: PLAT-17630 — model types whose editors get the Insert Math Equation button. Equations
// are self-contained `<img data-is-equation>` base64 SVGs, so nothing downstream needs a per-type
// branch; this list is the whole gate. The library builder inherits `library_text_builder` from
// ReferenceMaterial#use_new_builder?, which is the only thing that mounts ReadingEditor.
export const EQUATION_MODEL_TYPES = ['Section', 'ReferenceMaterial'];
